import React, { createRef } from 'react';
import './App.css';
import {Switch} from 'react-router-dom';
import Main from './view/Main';
//import SignUp from './view/Signup';
import {createStore,applyMiddleware,combineReducers} from 'redux';
import createSagaMiddleware from 'redux-saga'
import reducers from './redux/ducks/index'
import rootSaga from './saga';
import {getDefaultLang} from './utils/Utils';
import { Provider } from 'react-redux';
import GlobalSnackBar from './component/GlobalSnackBar';
import {MessCode} from './lang'
import {SnackbarProvider} from 'notistack';
import LocalizedStrings from 'react-localization';

// export var MyMess = new LocalizedStrings({
//   en:{
//     goodDay:"en goodDay"
//   },
//   zhTW:{
//     goodDay:"zhTW goodDay"
//   }
//  });

 export var MyMess = new LocalizedStrings(MessCode)
 MyMess.setLanguage(getDefaultLang());

const rootReducer = combineReducers(reducers);

const sagaMiddleware = createSagaMiddleware()
export const store = createStore(
  rootReducer,
  applyMiddleware(sagaMiddleware)
)

sagaMiddleware.run(rootSaga);
export var history = {};

export default function App(props) {
  history = props.history;
  history.hashId = "abcd";
 
  return (     
  <Provider store={store}>   
    <SnackbarProvider maxSnack={4}>
      <GlobalSnackBar/>      
    </SnackbarProvider>
      <Switch>             
        <Main></Main>
      </Switch>      
    
    
        
  </Provider>    
  
  );
}


// const App = (props) => {    
//     history = props.history;
//     history.hashId = "abcd";   
//     //const dispatch = useDispatch();  
//     useEffect(() => {
//       //checkUserLogin
//       //dispatch(asyncSignin('',''))
//       return () => {
        
//       }
//     }, [])
//     return (     
//     <Provider store={store}>
//       <GlobalSnackBar />      
//       <Switch>        
//         <Route exact path="/login" render={(props) => <Login {...props}></Login>}/>          
//         <Route path="/main" >
//           <Main></Main>
//         </Route>      
//         <Route path="/router" render={(props) => <Router {...props}></Router>}>          
//         </Route>        
//         <Route exact path="/signupform" render={(props) => <SignUpForm {...props}></SignUpForm>}/>          

//       </Switch>  
//     </Provider>    

//     );

  
// }

// export default App;
